// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"38fe47b1","856":"b8e4b4de"}[chunkId] + ".js";
};